import { VoucherInfoResponse } from '../interfaces'

export const toVoucherPaylod = (voucherInfo: VoucherInfoResponse) => ({
  barcode: voucherInfo.barcode,
  cashRegisterId: voucherInfo.cashRegisterId,
  currency: voucherInfo.currency,
  deposit: voucherInfo.deposit,
  isUsed: voucherInfo.isUsed,
  receivedResponse: voucherInfo.receivedResponse,
  reservedUntil: voucherInfo.reservedUntil,
  rvm: voucherInfo.rvm,
  storeId: voucherInfo.storeId,
  voucherId: voucherInfo.voucherId
})
